import { render, staticRenderFns } from "./AgendaStatiListPage.vue?vue&type=template&id=78451081&scoped=true"
import script from "./AgendaStatiListPage.vue?vue&type=script&lang=js"
export * from "./AgendaStatiListPage.vue?vue&type=script&lang=js"
import style0 from "./AgendaStatiListPage.vue?vue&type=style&index=0&id=78451081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78451081",
  null
  
)

export default component.exports